window.dataLayer = window.dataLayer || [];
export function gtag() {
  window.dataLayer.push(arguments);
}

// Default consent: deny until user accepts
gtag("consent", "default", {
  ad_storage: "denied",
  analytics_storage: "denied",
});
/*export const loadGTM1 = (id) => {
  if (document.getElementById("gtm-script")) return;
  const script = document.createElement("script");
  script.id = "gtm-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  document.head.appendChild(script);

  const noscript = document.createElement("noscript");
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  noscript.id = "gtm-noscript";
  document.body.appendChild(noscript);
};*/

export const loadGTM = (id) => {
  if (document.getElementById("gtm-script")) return;

  // Consent update to granted (after user accepts)
  gtag("consent", "update", {
    ad_storage: "granted",
    analytics_storage: "granted",
  });

  const script = document.createElement("script");
  script.id = "gtm-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  document.head.appendChild(script);

  const noscript = document.createElement("noscript");
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  noscript.id = "gtm-noscript";
  document.body.appendChild(noscript);
};

/*export const removeGTM1 = (id) => {
  const existingScript = document.getElementById("gtm-script");
  if (existingScript) existingScript.remove();

  const existingNoScript = document.getElementById("gtm-noscript");
  if (existingNoScript) existingNoScript.remove();

  // List of GTM/GA cookies to remove
  const gtmCookies = ["_ga", `_ga_${id}`];

  // Function to delete a cookie
  const deleteCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.${window.location.hostname}; path=/;`;
  };

  gtmCookies.forEach((cookie) => deleteCookie(cookie));
};*/

export const removeGTM = (id) => {
  const existingScript = document.getElementById("gtm-script");
  if (existingScript) existingScript.remove();

  const existingNoScript = document.getElementById("gtm-noscript");
  if (existingNoScript) existingNoScript.remove();

  // Reset consent back to denied
  gtag("consent", "update", {
    ad_storage: "denied",
    analytics_storage: "denied",
  });

  // Clean up GTM/GA cookies
  const gtmCookies = ["_ga", `_ga_${id}`];

  const deleteCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.${window.location.hostname}; path=/;`;
  };

  gtmCookies.forEach((cookie) => deleteCookie(cookie));
};
